import { render } from "./PeopleView.vue?vue&type=template&id=2956ed62"
import script from "./PeopleView.vue?vue&type=script&lang=js"
export * from "./PeopleView.vue?vue&type=script&lang=js"

import "./PeopleView.vue?vue&type=style&index=0&id=2956ed62&lang=scss"

import exportComponent from "/Users/cschultz/Code/iib/wp-content/plugins/ibj-people/people/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__